// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Chile from '../_raw/flag/icon_flag_chile.png';

export default () => <img src={Chile} alt="Chile" />;
